<template>
  <div class="center pad-bottom20">
    <div class="nav">
      <ul>
        <li><router-link :to="'/'">首页</router-link></li>
        <li>
          <router-link :to="'/list'" class="current">新闻公告</router-link>
        </li>
        <li><router-link :to="'/jobfair'">现场招聘</router-link></li>
        <li>
          <router-link :to="'/subject'">网络招聘会</router-link>
        </li>
        <li>
          <router-link :to="'/guidance'">办事指南</router-link>
        </li>
      </ul>
    </div>
    <el-container>
      <el-header class="box padding-20">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link :to="'/'">首页</router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>新闻列表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <el-main class="padding-0 margin-t-20">
        <div class="sidebar">
          <list-category :active="newstype"></list-category>
        </div>
        <div class="sidebar-right">
          <!-- <notice-category v-if="newstype === 'notice'"></notice-category> -->
          <list></list>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import list from './list'
import listCategory from './listCategory'
import noticeCategory from './noticeCategory'
export default {
  components: {
    list,
    listCategory,
    noticeCategory,
  },
  data() {
    return {
      newstype: '',
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        // let that = this
        // if (route.query) {
        //   if (route.query.newstype && route.query.newstype === 'news') {
        //     this.newstype = route.query.nav
        //   } else {
        //     this.newstype = 'notice'
        //   }
        // }
        // console.log(route.query.newstype)
        if (route.query.newstype) {
          if (route.query.newstype === 'xwgg') {
            this.newstype = 'xwgg'
          } else if (route.query.newstype === 'szdt') {
            this.newstype = 'szdt'
          } else if (route.query.newstype === 'jycy') {
            this.newstype = 'jycy'
          }
        } else {
          this.newstype = 'xwgg'
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('../../styles/main.scss');
</style>
<style lang="scss">
.el-menu {
  border-right: none;
}

.el-pagination {
  span,
  button {
    height: 28px !important;
    line-height: 28px !important;
  }
}

.el-pager {
  li {
    height: 28px !important;
    line-height: 28px !important;
    border-bottom: none !important;
    width: 28px !important;
    margin: 0 5px;
    background: #f4f4f5 !important;
  }

  li:hover {
    border-bottom: none !important;
    background: none !important;
  }
}

.wenZhang {
  min-height: 300px;
}

.bottom-btn-area {
  position: absolute !important;
  height: 60px !important;
  width: inherit !important;
  bottom: 0;
}

.bottom-btn-area {
  height: inherit !important;
  width: inherit !important;
}

.content {
  display: block;
  position: relative;
  height: auto !important;
  margin: auto auto 80px auto !important;
  width: 100% !important;

  p {
    line-height: 2rem;
    text-indent: 0;
    color: #000;
  }

  a {
    line-height: 2rem;
    text-indent: 0;
    color: #0000ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/list/index.vue